// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonMarkdownEditor = {
  emptyPreview: "Markdown コンテンツはまだありません",
  modes: {
    edit: "編集",
    split: "分割",
    preview: "プレビュー",
  },
  toolbar: {
    heading: "見出し",
    bold: "太字",
    italic: "斜体",
    quote: "引用",
    bulletList: "箇条書き",
    orderedList: "番号付きリスト",
    link: "リンク",
    codeBlock: "コードブロック",
  },
  placeholders: {
    heading: "セクション見出し",
    bold: "太字テキスト",
    italic: "斜体テキスト",
    quote: "引用メモ",
    bulletList: "リスト項目",
    orderedList: "リスト項目",
    link: "リンクテキスト",
    codeBlock: "コード",
  },
} as const;
